module.exports = __webpack_public_path__ + "img/app_store.44b3ae46.svg";